import {Select, Box, Container, Grid, Heading, Input, VStack, Image, Button } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { createCourse } from '../../../redux/actions/admin';
import Sidebar from '../Sidebar'

const CreateCourse = () => {
    const [title,setTitle]=useState();
    const [description,setDescription]=useState();
    const [createdBy,setCreatedBy]=useState();
    const [category,setCategory]=useState();
    const [img,setImg]=useState();
    const [imgPrev,setImgPrev]=useState();
    const categories = [
        "web dev" , "ml","cp" ,"app dev" ,"dsa"
    ]
    const dispatch = useDispatch();
    const {loading,error,message} = useSelector(state=>state.admin)
    const changeImgHandler=(e)=>{
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend=()=>{
            setImgPrev(reader.result);
            setImg(file);
        }
    }
    const submitHandler = (e) =>{
        e.preventDefault();
        const myForm = new FormData();

        myForm.append("title",title);
        myForm.append("description",description);
        myForm.append("category",category);
        myForm.append("createdBy",createdBy);
        myForm.append("file",img);

        dispatch(createCourse(myForm));
    }
    useEffect(() => {
      if(error){
      toast.error(error);
      dispatch({type:'clearError'})
    }
    if(message){
      toast.success(message);
      dispatch({type:'clearMessage'})
    }
    }, [dispatch,error,message]);
    
  return (
    <Grid minH={'100vh'} templateColumns={['1fr','5fr 1fr']} >
        <Container py='16'>
            <form onSubmit={submitHandler}>
                <Heading textTransform={'uppercase'} children='Create Course' my='16' textAlign={['center','left']}/>
                <VStack m='auto' spacing={'8'}>
                    <Input required value={title} onChange={(e)=>setTitle(e.target.value)} placeholder='Title' type='text' focusBorderColor='purple.300' />
                    <Input required value={description} onChange={(e)=>setDescription(e.target.value)} placeholder='Description' type='text' focusBorderColor='purple.300' />
                    <Input required value={createdBy} onChange={(e)=>setCreatedBy(e.target.value)} placeholder='Creator Name' type='text' focusBorderColor='purple.300' />
                    <Select focusBorderColor='purple.300' value={category} onChange={e=>setCategory(e.target.value)}>
                        <option value=''>Select Category</option>
                        {categories.map(item=>(
                            <option key={item} value={item}>{item}</option>
                        ))}
                    </Select>
                    <Input accept='image/*' required id='chooseAvatar' type={'file'} focusBorderColor='purple.300' 
                       css={{
                        "&::file-selector-button":{
                            cursor:"pointer",marginLeft:"-5%",
                            width:"110%",
                            border:"none",
                            height:"100%",
                            color:'purple',
                            backgroundColor:'white'
                        }
                       }}
                       onChange={changeImgHandler}
                    />
                    {imgPrev && (
                        <Image src={imgPrev} boxSize='64' objectFit={'contain'} />
                    )}
                    <Button isLoading={loading} w='full' colorScheme={'purple'} type='submit'>
                        Create Course
                    </Button>
                </VStack>
            </form>
        </Container>
        <Sidebar/>
    </Grid>
  )
}

export default CreateCourse